import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MasterarbeitsanmeldungVariables } from "../masterarbeitsanmeldung.variables";
import { InformationElementComponent } from "@alf-nx-workspace/shared/ui";
import { NgIf } from "@angular/common";
import { BaseInformationTemplateComponent } from "../../base-information-template.component";


@Component({
  selector: 'masterarbeitsanmeldung-information-template',
  templateUrl: './information-template.component.html',
  styleUrls: ['./information-template.component.scss'],
  standalone: true,
  imports: [NgIf, InformationElementComponent],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class InformationTemplateComponent extends BaseInformationTemplateComponent {

  public readonly fields = MasterarbeitsanmeldungVariables;

  public getInformationElementAntragssteller() {
    if (this.isSet(this.fields.nameStudent)) {
      return {
        name: 'MASTERARBEITSANMELDUNG.ANTRAGSSTELLER',
        value: `${this.variableMap.get(this.fields.nameStudent)} (${this.variableMap.get(this.fields.matrikelnummer)})`,
      };
    }
  }

  protected getInformationElementStudium() {
    if (this.isSet(this.fields.studienkennzahl)) {
      return {
        name: 'MASTERARBEITSANMELDUNG.STUDIENKENNZAHL',
        value: `${this.variableMap.get(this.fields.studienkennzahl)}`
      };
    }
  }

  protected getInformationElementArbeitstitel() {
    if (this.isSet(this.fields.arbeitstitel)) {
      return {
        name: 'MASTERARBEITSANMELDUNG.ARBEITSTITEL',
        value: `${this.variableMap.get(this.fields.arbeitstitel)}`,
      };
    }
  }

  protected getInformationElementOrganisation() {
    if (this.isSet(this.fields.organisation_LABEL)) {
      return {
        name: 'MASTERARBEITSANMELDUNG.ORGANISATION',
        value: `${this.variableMap.get(this.fields.organisation_LABEL)}`,
      };
    }
  }

  protected getInformationElementAntragstyp() {
    if (this.isSet(this.fields.typAntragMasterarbeit_LABEL)) {
       return {
        name: 'MASTERARBEITSANMELDUNG.ANTRAGSTYP',
        value: `${this.variableMap.get(this.fields.typAntragMasterarbeit_LABEL)}`,
      };
    }
  }

  protected getInformationElementBetreuer() {
    if (this.isSet(this.fields.hauptbetreuungIntern1_LABEL)) {
      return {
        name: 'MASTERARBEITSANMELDUNG.HAUPTBETREUER',
        value: `${this.variableMap.get(this.fields.hauptbetreuungIntern1_LABEL)}`,
      };
    }
  }

  private isSet(fieldId: string): boolean {
    if (!fieldId) return false;
    const value = this.variableMap.get(fieldId);
    return !!value;
  }


}
